import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "75%",
  },
}));

var i = 0;

const FilledTimeslots = ({ timeslots, handleChange }) => {
  const classes = useStyles();
  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      style={{ marginTop: "1.5em" }}
    >
      <InputLabel id="demo-simple-select-outlined-label">
        Select Timeslots
      </InputLabel>
      <Select
        labelId="demo-simple-select-outlined-label"
        id="demo-simple-select-outlined"
        onChange={handleChange}
        label="Select Timeslot"
        name="timeslot"
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>

        {timeslots.map((item) => (
          <MenuItem value={item} key={i++}>
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilledTimeslots;
